<div class="m-3">
  <div>
    <table class="table">
      <tr class="row">
        <td class="col-6 text-start">
          <a href="/tenants" class="link-primary cursorPointer">{{tenantId}}</a>@if (mode!='admin') {
          <span>/</span>
          }Transactions
        </td>
        <td class="col-6 text-end">
          @if (filteredTransactions.length > 0 && errorMessage === '' && !isLoading) {
            <span>
              <button class="btn btn-sm font-weight-bold btn-link" (click)="exportToExcel()">
                <i class="fa fa-external-link"></i>
                Export to Excel
              </button>
              <button class="btn btn-sm font-weight-bold btn-link" (click)="exportToCsv()">
                <i class="fa fa-external-link"></i>
                Export to CSV
              </button>
            </span>
          }
        </td>
      </tr>
    </table>


  </div>
  <div class="table-responsive-sm m-3">
    <ul class="nav nav-tabs mb-3" id="myTab0" role="tablist">
      @if (mode!='admin') {
        <li class="nav-item" role="presentation">
          <button class="nav-link active"
            id="billingByDateTab"
            data-bs-toggle="tab"
            data-bs-target="#billingByDateContent"
            type="button"
            role="tab"
            aria-controls="billingByDateContent0"
            aria-selected="true" [disabled]="isLoading" (click)="resetData()">
            Transactions By Date
          </button>
        </li>
      }
      @if (mode!='admin') {
        <li class="nav-item" role="presentation">
          <button class="nav-link"
            id="profile-tab0"
            data-bs-toggle="tab"
            data-bs-target="#billingByTransactionContent"
            type="button"
            role="tab"
            aria-controls="billingByTransactionContent0"
            aria-selected="false" [disabled]="isLoading" (click)="resetData()">
            Transactions After this TransactionId
          </button>
        </li>
      }


    </ul>
    <div class="tab-content" id="myTabContent0">
      @if (mode!='admin') {
        <div class="tab-pane fade show active"
          id="billingByDateContent"
          role="tabpanel"
          aria-labelledby="billingByDateTab-tab0">
          <table>
            <tr class="">
              <td class="col-5">
                <input placeholder="yyyy-MM-dd"
                  name="dp" ngbDatepicker #dfromDate="ngbDatepicker" [(ngModel)]="fromDate">
                <button (click)="dfromDate.toggle()" type="button"><i class="bi bi-calendar"></i></button>
              </td>
              <td class="col-5">
                <input placeholder="yyyy-MM-dd"
                  name="dp" ngbDatepicker #dtoDate="ngbDatepicker" [(ngModel)]="toDate">
                <button (click)="dtoDate.toggle()" type="button"><i class="bi bi-calendar"></i></button>
              </td>
              <td class="col-5">
                <button type="button" (click)="billingByDate()" class="btn btn-info">Billing By Date</button>
              </td>
            </tr>
          </table>
        </div>
      }
      @if (mode!='admin') {
        <div class="tab-pane fade" id="billingByTenantContent" role="tabpanel" aria-labelledby="billingByTenantContent-tab0">
        </div>
      }
      @if (mode!='admin') {
        <div class="tab-pane fade"
          id="billingByTransactionContent"
          role="tabpanel"
          aria-labelledby="billingByTransactionContent-tab0">
          <table>
            <tr class="">
              <td class="col-5 text-start">
                <input type="text" appTrim [(ngModel)]="searchTransactionId" name="txtSearchTransactionId" id="txtSearchTransactionId" required #txtSearchTransactionId="ngModel" pattern="[a-zA-Z0-9]{1,50}" minlength="1" maxlength="50" />
              </td>
              <td class="col-5 text-start">
                <button type="button" (click)="billingByTransactionId()" class="btn btn-info">Transactions After this Id</button>
              </td>
            </tr>
          </table>
        </div>
      }
    </div>
    @if (filteredTransactions.length == 0 && errorMessage === '' && !isLoading) {
      <div class="container divHover  m-5">
        No Transactions available
      </div>
    }
    @if (!isLoading) {
      <div class="container divHover  m-5">
        {{errorMessage}}
      </div>
    }
    @if (isLoading) {
      <div class="d-flex justify-content-center m-5">
        <div class="spinner-border" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    }
    @if (filteredTransactions.length > 0) {
      <div class="table-responsive-sm">
        <table class="table">
          <thead>
            <tr>
              <th columnSort class="tableHeader" [data]="filteredTransactions" data-order="desc" data-name="tenantId">
                Tenant Id
              </th>
              <th columnSort class="tableHeader" [data]="filteredTransactions" data-order="desc" data-name="accessKey">
                Tenant Access Key
              </th>
              <th columnSort class="tableHeader" [data]="filteredTransactions" data-order="desc" data-name="transactionId">
                TransactionId
              </th>
              <th columnSort class="tableHeader" [data]="filteredTransactions" data-order="desc" data-name="transactionJson">
                TransactionJSON
              </th>
              <th columnSort class="tableHeader" [data]="filteredTransactions" data-order="desc" data-name="updateDate">
                Transaction Date
              </th>
              <th columnSort class="tableHeader" [data]="filteredTransactions" data-order="desc" data-name="flow_id">
                Flow_Id
              </th>
              <th columnSort class="tableHeader" [data]="filteredTransactions" data-order="desc" data-name="tsn">
                TSN
              </th>
            </tr>
          </thead>
          @for (transaction of (filteredTransactions | paginate: {id:'datePagination', itemsPerPage:15, currentPage: p} ); track transaction) {
            <tbody>
              @if (transaction.id != undefined) {
                <tr>
                  <td class="tableColumn text-truncate">{{transaction.id}}</td>
                  <td class="tableColumn text-truncate">{{transaction.accessKey}}</td>
                  <td class="tableColumn text-truncate">{{transaction.transactionId}}</td>
                  <td class="tableColumn text-truncate">{{transaction.transactionJSON}}</td>
                  <td class="tableColumn text-truncate">{{transaction.updateDate}}</td>
                  <td class="tableColumn text-truncate">{{transaction.flow_id}}</td>
                  <td class="tableColumn text-truncate">{{transaction.tsn}}</td>
                </tr>
              }
            </tbody>
          }
        </table>
        <pagination-controls id="datePagination" (pageChange)="p = $event" [directionLinks]="true"
          [autoHide]="true"
          [responsive]="true"
          previousLabel="Previous"
          nextLabel="Next"
          screenReaderPaginationLabel="Pagination"
          screenReaderPageLabel="page"
        screenReaderCurrentLabel="You're on page"></pagination-controls>
      </div>
    }

  </div>
</div>
